import Rest from '../Rest'

export default class PhoneTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/phone_types'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
